export const validateSearchInput = (input) => {
    // Strict validation pattern
    if (!input || typeof input !== 'string') return '';
    
    // Allow Unicode letters (including accented characters), numbers, spaces, and common name characters
    // \p{L} matches any Unicode letter character (including accented letters)
    return input.replace(/[^\p{L}0-9\s\-\.,']/gu, '').trim();
  };